import { render } from "./StaticWebUrlLayoutEditor.vue?vue&type=template&id=3841544c&scoped=true&ts=true"
import script from "./StaticWebUrlLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./StaticWebUrlLayoutEditor.vue?vue&type=script&lang=ts"

import "./StaticWebUrlLayoutEditor.vue?vue&type=style&index=0&id=3841544c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3841544c"]])

export default __exports__